<template>
  <div :class="$vuetify.breakpoint.mdAndUp?'pt-8 pb-8 pr-8 pl-8':'pt-2 pb-2 pr-1 pl-1'">
    <v-card class="mx-auto" max-width="1100">
      <v-container fluid>
        <v-row dense>
          <v-col v-for="(entry) in entries" :key="entry.id" :cols="$vuetify.breakpoint.mdAndUp?4:6">
            <article-card
              class="text-right"
              :id="entry.id"
              :title="entry.title"
              :img-src="entry.imgUrl ? entry.imgUrl+'?w=600' : '/img/noimage.png'"
              :date="entry.date"
            ></article-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import { EventBus } from "@/event.js";

import ArticleCard from "@/components/ArticleCard.vue";

const dateFormat = require("dateformat");
const contentful = require("contentful");
const client = contentful.createClient({
  space: process.env.VUE_APP_CONTENTFUL_SPACE_ID,
  accessToken: process.env.VUE_APP_CONTENTFUL_ACCESS_TOKEN
});

export default {
  components: {
    ArticleCard
  },
  data() {
    return {
      entries: []
    };
  },
  metaInfo: {
    title: "Home",
    meta: [
      {
        property: "og:type",
        content: "website",
        vmid: "og:type"
      }
    ]
  },
  methods: {},
  created() {
    // change i18n locale from path params
    const locale = this.$route.params.locale;
    document.documentElement.lang = locale;
    this.$root.$i18n.locale = locale;
    EventBus.$emit("loading", true);
    const that = this;
    client
      .getEntries({
        content_type: "article",
        locale
      })
      .then(entries => {
        that.entries = entries.items.map(item => {
          return {
            id: item.sys.id,
            title: item.fields.title,
            imgUrl: item.fields.headerImage.fields.file.url,
            date: dateFormat(Date.parse(item.sys.createdAt), "yyyy/m/d ddd")
          };
        });
        EventBus.$emit("loading", false);
      })
      .catch(err => {
        console.log(err);
        EventBus.$emit("loading", false);
      });
  }
};
</script>

<i18n>
{
  "en": {
    "message": "This space will show articles"
  },
  "ja": {
    "message": "ここに記事が表示されます"
  }
}
</i18n>

<style scoped>
</style>